var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Banner, DataTable, FlexBox, Icon, Page, Text, } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { flowsApi } from 'apis/flows';
import { useAppPathParams } from 'utils/url/useAppPathParams';
const flowChannelNameMap = {
    phone: 'Phone',
    email: 'Email',
    chat: 'Chat',
    'dixa-messenger': 'Messenger',
};
export function SettingsFlowAuditLogView({ channel, }) {
    var _a, _b;
    const { flowId } = useAppPathParams(`/settings/${channel}/flow/:flowId/history`);
    const { flow, refetch, isError, isLoading } = flowsApi.useReadFlowQuery({ id: flowId }, {
        selectFromResult: (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign({ flow: data === null || data === void 0 ? void 0 : data.data }, rest));
        },
    });
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: _jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center" }, { children: [_jsx(Link, Object.assign({ to: `/settings/${channel}`, style: { color: 'inherit' } }, { children: flowChannelNameMap[channel] })), _jsx(Icon, { name: "angle-right" }), flow === null || flow === void 0 ? void 0 : flow.name] })) }), _jsx(Page.Body, { children: _jsx(Page.Section, Object.assign({ title: "Audit log", callout: _jsx(Banner, { variant: "info", description: _jsx(Text.Paragraph, Object.assign({ as: "span", variant: "4" }, { children: "Any entries older than 3 months will be automatically deleted." })) }) }, { children: _jsx(DataTable, { columns: [
                            {
                                label: 'Edit',
                                selector: ({ updated_by }) => updated_by,
                                style: {
                                    width: '70%',
                                },
                            },
                            {
                                label: 'Date',
                                selector: ({ updated_at }) => {
                                    const time = moment(updated_at);
                                    const localeData = moment.localeData();
                                    return time.format(`DD MMMM YYYY, ${localeData.longDateFormat('LT')}`);
                                },
                            },
                        ], data: (_a = flow === null || flow === void 0 ? void 0 : flow.updated_by_history) !== null && _a !== void 0 ? _a : [], tableStatusProps: {
                            loading: isLoading,
                            loadingFailed: isError,
                            onLoadingRetry: refetch,
                            emptyState: !isLoading && !isError && ((_b = flow === null || flow === void 0 ? void 0 : flow.updated_by_history) === null || _b === void 0 ? void 0 : _b.length) === 0
                                ? {
                                    title: 'No data available',
                                    description: 'We store data for 3 months. Any activity older than this will be deleted and not be displayed.',
                                }
                                : undefined,
                        } }) })) })] }));
}
